import React,{useState} from 'react';
import '../App.css';
//import RenderPdf from '../utils/RenderPdf.js';
//import {AiFillHome} from 'react-icons/ai';
//import {Profile,Personality,Feedback1,AvatarPersonality1,ActiveExperiments,EMAIL} from '../utils/Constants.js';
import {AllExperiments,ENDPOINT} from '../utils/Constants.js';
import {FaFileDownload} from 'react-icons/fa';
import VideoChat from './VideoChat.js';
import {IoChatbubbles} from 'react-icons/io5';

function Wizard(props){
/*
props{
    userInfo{
      username,
      userID,
      group (=avatar personality=roomNr:1 for openfriendlysociable, 2 for quietsadreclusive)
  },
   onChange()
  }
*/
//Participant webpage
  let {signedIn, userToken, userName, userID, role} = props.userInfo;
  let [page,setPage]=useState("Start");
  let [isLoading, setIsLoading]=useState(false);
  let [loadError, setLoadError]=useState('');
//  let [experiment, setExperiment]=useState('');
  //on server response change data
  function onResponseChangeState(message){
      setLoadError(message);
      setIsLoading(false);
  }
  //API call to get survey data
  function onSurveyDL(ex){
    console.log('Downloading data from',ex);
    setIsLoading(true);
    fetch(ENDPOINT + '/api/account/getforms',
    {
      method: 'POST',
      headers:{
        'Content-Type':'application/json'
        },
      body: JSON.stringify({
        userID:userID,
        userToken:userToken,
        exID:ex
        })
    })
    .then(res => res.json())
        .then(json => {
            if(json.success){
              //update App state
              onResponseChangeState('')
              console.log(json.data)
              toCSV(json.data,ex)
            }
            else{
              onResponseChangeState(json.message)
            }
        });
  }
  function updateSurveys(dataToUpdate){
    setIsLoading(true);
    console.log("Updating format for old replies")
    fetch(ENDPOINT + '/api/account/updatesurveyformat',
    {
      method: 'POST',
      headers:{
        'Content-Type':'application/json'
        },
      body: JSON.stringify({
        userID:userID,
        userToken:userToken,
        data:dataToUpdate
      })
    })
    .then(res => res.json())
        .then(json => {
            if(json.success.includes(false)){
              //update App state
              onResponseChangeState(json.message)

            }
            else{
              onResponseChangeState('')
              console.log("Reformatting user records was successful")
            }
        })
  }
  //convert old survey format from ex1 to new format for multiple experiments
  function convertOld(data){
    let dataToUpdate = [];
    let newData = data;
    data.forEach((item,idx) => {
      if (item['surveyData'].hasOwnProperty('startTime')){
        dataToUpdate.push({
          _id:item._id,
          surveyData:{ex1:item.surveyData}
        })
        console.log('Before:',newData[idx].surveyData)
        newData[idx].surveyData={ex1:item.surveyData}
        console.log('After:',newData[idx].surveyData)
      }
    })
    if(dataToUpdate.length>0){
      console.log('Data to update:',dataToUpdate)
      updateSurveys(dataToUpdate)
    }
    return newData
  }
  function toCSV(data,experiment){
    let newData = convertOld(data)
    //create string for the csv Header of the survey data
    let csvHeader = "UserID\tGroup\tStartTime\tEndTime";
    AllExperiments[experiment]["parts"].forEach((form,idx)=>{
      if (AllExperiments[experiment]["types"][idx]==="Form"){
        form.data.forEach((item)=>{csvHeader+="\t"+item.id});
      };
    });
    csvHeader+="\n"
    //format data as csv
    let csv = csvHeader; //csv string starting with the header
    newData.forEach((item) => {
      let csvRow = item._id+"\t"+item.group+"\t"
      if(item.surveyData.hasOwnProperty(experiment)){
        let expDat=item['surveyData'][experiment]
        expDat.startTime ? csvRow+=expDat.startTime+"\t":csvRow+=" \t";
        expDat.endTime ? csvRow+=expDat.endTime+"\t":csvRow+=" \t";
        AllExperiments[experiment]["pages"].forEach((form,idx)=>{
          if (AllExperiments[experiment]["types"][idx]==="Form"){
            csvRow+=expDat[form].join(" \t")+"\t";
          }
        })
      }
      //console.log(csvRow)
      csvRow=csvRow.replace(/\n\r?/g," | ");
      csv+=csvRow+"\n";
      });
    //console.log(csv);
    var hiddenElement = document.getElementById("csv");
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
    hiddenElement.target = '_blank';
    hiddenElement.download = 'SurveyData'+experiment+'.csv';//add timestamp
    hiddenElement.click();
  }
  const pages = ["Start","Chat0","Chat1","Chat2","SurveyData"]
  // Functions for user pages
  let startPage=()=>{
    return(
      <div className="center" style={{maxWidth: "600px",margin: "auto"}}>
        <h1 className="title">Welcome to ODE</h1>
        <h2 className="title">The Online Dialogue Experiment WebApp</h2>
        <p >Using the buttons below, you can either enter the video chat or download the experiment data of all users who have participated in the experiment so far. </p>
        <p>Enjoy!</p>
        <h2 style={{display: signedIn ? "block" : "none"}}> Congrats, {userName}! You are a wizard :)</h2>
        <button
          style={{display: "inline-flex"}}
          className="textButton blue flexButton"
          onClick={()=>setPage(pages[1])}>VideoChat <IoChatbubbles className="iconR"/>
        </button>
        {Object.keys(AllExperiments).map((ex)=>(
          <button
            style={{display: "inline-flex"}}
            className="textButton blue"
            onClick={()=>{onSurveyDL(ex)}}>SurveyData {ex} <FaFileDownload className="iconR"/>
          </button>))}
        <a id="csv" href="/"> </a>
        <p style={{display: isLoading ? "block" : "none"}}>Retrieving your data...</p>
        <p className="error" style={{display: loadError!=='' ? "block" : "none"}}>{loadError}.</p>
      </div>
    )
  }
  function leavePage(newPage){
     setPage(newPage)
   }

  let chatPage=(room)=>{
    return(
      <div className="center" >
        <h1 className="title">VideoChat</h1>
        <VideoChat
        userInfo={{userToken:userToken, userName:userName, userID:userID, role:role, group:room, }}
        nextPage={pages[0]}
        onChange={leavePage}
        />
      </div>
    )
  }
  console.log("WizardPage: ",page)

  //useEffect(parseSurvey({survey:AvatarPersonality,name:"avatar",vis:showDescription}),[showDescription])

  return(

    <div className='center'>
      {
        page===pages[0]? startPage()
        : page===pages[1]? chatPage(0)
        : <div>Empty page</div>
      }
    </div>
  )
}

export default Wizard
